import type { SpinnerProps } from '@shopify/polaris';

import { classNames } from '~/presentation/common';
import { Spinner } from '@shopify/polaris';

export interface GSpinnerProps extends SpinnerProps {
  tone?: 'subdued';
}
export const GSpinner = (props: GSpinnerProps) => {
  return (
    <div
      className={classNames('Polaris-GSpinner', props.tone && `Polaris-GSpinner--${props.tone}`)}
    >
      <Spinner {...props} />
    </div>
  );
};
